module.exports = __webpack_public_path__ + "img/comp-table-brand-interactions.bff83496.png";